// Firebase analytics implementation
export enum EVENT {
  SV_PING_LOCATION = "sv_ping_location",
  UE_GEO_TRACKING_ACCEPTANCE = "ue_geo_tracking_acceptance",
  UE_GEO_TRACKING_DENIAL = "ue_geo_tracking_denial",
  UE_GEO_TRACKING = "ue_geo_tracking",
  SV_STOP_ARRIVAL = "sv_stop_arrival",
  UE_STOP_ARRIVAL = "ue_stop_arrival",
  SV_STOP_ETA = "sv_stop_eta",
  UE_STOP_ETA = "ue_stop_eta",
  SV_STOP_DEPARTURE = "sv_stop_departure",
  UE_STOP_DEPARTURE = "ue_stop_departure",
  SV_TRAILER_IN = "sv_trailer_in",
  UE_TRAILER_IN = "ue_trailer_in",
  SV_TRAILER_OUT = "sv_trailer_out",
  UE_TRAILER_OUT = "ue_trailer_out",
  SV_THANK_NOTE = "sv_thank_note",
  SV_ASSIGN_DRIVER = "sv_assign_driver",
  SV_DISPATCHER_DETAILS = "sv_dispatcher_details",
  UE_ASSIGN_DRIVER_YES = "ue_assign_driver_yes",
  UE_DETERMINE_STOP_ACTIVITY ="ue_determine_stopactivity",
  UE_ASSIGN_DRIVER_NO = "ue_assign_driver_no",
  SV_ASSIGN_DRIVER_DETAILS = "sv_assign_driver_details",
  UE_ASSIGN_DRIVER_SAVE = "ue_assign_driver_save",
  UE_DISPATCHER_DETAILS_SAVE = "ue_dispatcher_detail_save",
  UE_ASSIGN_DRIVER_SUCCESS = "ue_assign_driver_success",
  UE_ASSIGN_DRIVER_FAILURE = "ue_assign_driver_failure",
  SV_SCDM_ACCEPTSHIPMENT ="sv_accept_shipment",
  SV_SCDM_ACCEPT_DECLINE ="sv_scdm_accept_decline_page",
  UE_SCDM_ACCEPT_SHIPMENT ="ue_scdm_accept_shipment",
  UE_SCDM_DECLINE_SHIPMENT ="ue_scdm_decline_shipment",
  SV_SCDM_END_ACTIVITY="sv_scdm_end_activity",
  UE_CQ_TRANSPORATION_MODE_USERFEED = "ue_cq_transporation_mode_userfeed",
  UE_CQ_TRANSPORATION_MODE_URLFEED = "ue_cq_transporation_mode_urlfeed",
  UE_CQ_PICKUP_DELIVERY_ANSWERFEED = "ue_cq_pickup_delivery_answerfeed",
  UE_CQ_DELIVERY_ANSWERFEED = "ue_cq_delivery_answerfeed",
  UE_CQ_COMMODITY_INFO_ANSWERFEED = "ue_cq_commodity_info_answerfeed",
  UE_CQ_CONTACT_INFO_ANSWERFEED = "ue_cq_contact_info_answerfeed",
  SV_CQ_SUCCESSFUL_THANKS = "sv_cq_successful_thanks",
  SV_CQ_LIMIT_EXCEEDED_THANKS = "sv_cq_limit_exceeded_thanks",
  SV_CQ_LOGIN_REQUESTED_THANKS = "sv_cq_login_requested_thanks",
  SV_CQ_DOMAIN_RESTRICTED_THANKS = "sv_cq_domain_restricted_thanks",
  UE_AD_SIGN_DETAILS = "ue_ad_sign_details",
}

export enum SCREEN {
  PING_LOCATION = "ping_location",
  STOP_ARRIVAL = "stop_arrival",
  STOP_ETA = "stop_eta",
  STOP_DEPARTURE = "stop_departure",
  TRAILER_IN = "trailer_in",
  TRAILER_OUT = "trailer_out",
  THANK_NOTE = "thank_note",
  DRIVER_ASSIGNMENT_QUESTION = "driver_assignment_question",
  DISPATCHER_DETAILS_QUESTION = "dispatcher_details_question",
  ASSIGN_DRIVER_DETAILS = "assign_driver_details",
  SCDM_ACCEPT_DECLINE_PAGE = "scdm_accept_decline_page",
  SV_SCDM_ACCEPT_DECLINE ="sv_scdm_accept_decline_page",
  SCDM_END_ACTIVITY ="scdm_end_activity",
  DISPATCHER_DETAILS = "dispatcher_details",
  AD_SIGN_DETAILS = "ad_sign_details",
  CUSTOMER_QUOTE_TRANSPORTATION_MODE = "customer_quote_transportation_mode",
  CUSTOMER_QUOTE_PICKUP_DELIVERY_INFO = "customer_quote_pickup_delivery_info",
  CUSTOMER_QUOTE_COMMODITY_INFO="customer_quote_commodity_info",
  CUSTOMER_QUOTE_DELIVERY_INFO = "customer_quote_delivery_info",
  SV_CQ_SUCCESSFUL_THANKS = "sv_cq_successful_thanks",
  SV_CQ_LIMIT_EXCEEDED_THANKS = "sv_cq_limit_exceeded_thanks",
  SV_CQ_LOGIN_REQUESTED_THANKS = "sv_cq_login_requested_thanks",
  SV_CQ_DOMAIN_RESTRICTED_THANKS = "sv_cq_domain_restricted_thanks"


}
